import { createReducer, on } from "@ngrx/store";
import { ReviewPageActions, TransactionFormActions } from "../actions";

export const transactionOptionsKey = 'transactionOptions';

export interface State {
  submitAndCreateToggledOn: boolean;
  saveAsTemplateToggledOn: boolean;
  templateNickname: string;
}

export const initialOptionsState: State = {
  submitAndCreateToggledOn: false,
  saveAsTemplateToggledOn: false,
  templateNickname: '',
};

export const reducer = createReducer(
  initialOptionsState,
  on(TransactionFormActions.loadReviewPage, (_) => {
    return initialOptionsState;
  }),
  on(ReviewPageActions.submitAndCreateToggled, (state, action) => {
    const { isSubmitAndCreate } = action;

    if (isSubmitAndCreate) {
      return {
        ...state,
        submitAndCreateToggledOn: isSubmitAndCreate,
        saveAsTemplateToggledOn: false,
      }
    }

    return {
      ...state,
      submitAndCreateToggledOn: isSubmitAndCreate,
    };
  }),
  on(ReviewPageActions.saveAsTemplateToggled, (state, action) => {
    const { isSaveAsTemplate } = action;

    if (isSaveAsTemplate) {
      return {
        ...state,
        submitAndCreateToggledOn: false,
        saveAsTemplateToggledOn: isSaveAsTemplate
      }
    }

    return {
      ...state,
      saveAsTemplateToggledOn: isSaveAsTemplate,
      templateNickname: '',
    };
  }),
  on(ReviewPageActions.updateTemplateNickname, (state, action) => {
    return {
      ...state,
      templateNickname: action.nickname
    }
  }),
)